import React, { useState, useEffect, useContext } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  IconButton,
  Tooltip,
  Typography,
  ButtonGroup
} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import FilterListIcon from '@mui/icons-material/FilterList';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import { GlobalContext } from '../../../App';
import ColumnFilter from './ColumnFilter';
import TableActions from './TableActions';

// const GenericTable = ({ columns, defaultRows = [], onRowsChange, rowStructure, searchText, onRowSelect = () => { } }) => {
  const GenericTable = ({
    columns,
    defaultRows = [],
    onRowsChange,
    rowStructure,
    searchText,
    onRowSelect = () => {},
    currentPage,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange
  }) => {

  const { permission } = useContext(GlobalContext);
  const lockedPermissions = [];
  const requiredPermissions = [1];

  const [anchorEl, setAnchorEl] = useState(null);
  const [filterColumn, setFilterColumn] = useState(null);
  const [rows, setRows] = useState(defaultRows.length > 0 ? defaultRows : [rowStructure]);
  const [originalRows] = useState([...defaultRows]);
  const [columnWidths, setColumnWidths] = useState(columns.map(column => column.width || 150));
  const [selectedRows, setSelectedRows] = useState({ rows: [], lastClick: null });
  const [editableRows, setEditableRows] = useState([]); // משתנה למעקב אחר השורות הנמצאות במצב עריכה
  const [updatedColumns, setUpdatedColumns] = useState(columns); // סטייט לעדכון העמודות עם הרוחב

  const [filters, setFilters] = useState({});

  // useEffect לסינון והגדרת הרשומות לפי ה-searchText
  useEffect(() => {
    if (searchText) {
      setRows(searchText);
    }
  }, [searchText]);

  // // ניהול הפילטר והדפדוף
  // const [rowsPerPage, setRowsPerPage] = useState(10); // מספר השורות שיוצגו בדף
  // const [currentPage, setCurrentPage] = useState(1);

  // פונקציה לבחירת מספר הרשומות להצגה בדף
  // const handleRowsPerPageChange = (event) => {
  //   setRowsPerPage(event.target.value);
  //   setCurrentPage(1); // איפוס לעמוד הראשון
  // };
  // פונקציה לבחירת מספר הרשומות להצגה בדף
const handleRowsPerPageChange = (event) => {
  console.log('4444');
  
  onRowsPerPageChange(event); // מפעיל את הפונקציה מהפרופס
  onPageChange(1); // איפוס לעמוד הראשון
};

  // // ניווט בין עמודים
  // const handleFirstPage = () => setCurrentPage(1);
  // const handleLastPage = () => setCurrentPage(Math.ceil(rows.length / rowsPerPage));
  // const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(rows.length / rowsPerPage)));
  // const handlePreviousPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  // ניווט בין עמודים
const handleFirstPage = () => onPageChange(1);
const handleLastPage = () => onPageChange(Math.ceil(rows.length / rowsPerPage));
const handleNextPage = () => onPageChange(Math.min(currentPage + 1, Math.ceil(rows.length / rowsPerPage)));
const handlePreviousPage = () => onPageChange(Math.max(currentPage - 1, 1));

  // חישוב השורות שיוצגו בעמוד הנוכחי
  const currentRows = rows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);


  const hasLockedPermission = () => permission === 0 || lockedPermissions.includes(permission);
  const hasRequiredPermission = () => permission === 0 || requiredPermissions.includes(permission);

  const handleFilterClick = (event, column) => {
    setAnchorEl(event.currentTarget);
    setFilterColumn(column);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
    setFilterColumn(null);
  };

  const handleFilterChange = (filterType, value, extraValue = null) => {
    // עדכון ערכי הפילטרים במצב המקומי
    const updatedFilters = {
      ...filters,
      [filterColumn.field]: { type: filterType, value, extraValue }
    };
    setFilters(updatedFilters);

    // הפעלת הסינון מחדש לפי הפילטרים המעודכנים
    let filteredRows = [...originalRows];

    // בדיקה של כל פילטר והפעלת הסינון בהתאם
    Object.keys(updatedFilters).forEach((field) => {
      const filter = updatedFilters[field];
      const { type, value, extraValue } = filter;

      if (type === 'equal' && value) {
        filteredRows = filteredRows.filter(row => String(row[field]) === value);
      } else if (type === 'startsWith' && value) {
        filteredRows = filteredRows.filter(row => String(row[field]).startsWith(value));
      } else if (type === 'endsWith' && value) {
        filteredRows = filteredRows.filter(row => String(row[field]).endsWith(value));
      } else if (type === 'contains' && value) {
        filteredRows = filteredRows.filter(row => String(row[field]).includes(value));
      } else if (type === 'notContains' && value) {
        filteredRows = filteredRows.filter(row => !String(row[field]).includes(value));
      } else if (type === 'specificDate' && value) {
        filteredRows = filteredRows.filter(row => {
          const rowDate = new Date(row[field]).toISOString().split('T')[0];
          return rowDate === value;
        });
      } else if (type === 'startDate' && value) {
        filteredRows = filteredRows.filter(row => new Date(row[field]) >= new Date(value));
      } else if (type === 'endDate' && value) {
        filteredRows = filteredRows.filter(row => new Date(row[field]) <= new Date(value));
      } else if (type === 'dateRange' && value && extraValue) {
        filteredRows = filteredRows.filter(row => {
          const rowDate = new Date(row[field]);
          return rowDate >= new Date(value) && rowDate <= new Date(extraValue);
        });
      }
    });

    // עדכון השורות בהתאם לסינון שבוצע
    setRows(filteredRows);
  };


  const handleInputChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const handleRowSelection = (rowIndex) => {
    const selectedRow = rows[rowIndex];
    let newSelectedRows = [];

    console.log(rowIndex);
    console.log(selectedRows);
    

    if (selectedRows.rows.includes(selectedRow)) {
      newSelectedRows = selectedRows.rows.filter(row => row !== selectedRow);
    } else {
      newSelectedRows = [...selectedRows.rows, selectedRow];
    }

    setSelectedRows({ ...selectedRows, rows: newSelectedRows });
  };

  // const handleRowClick = (rowIndex) => {
  //   const currentTime = new Date().getTime();
  //   if (selectedRows.lastClick && (currentTime - selectedRows.lastClick) < 300) { // זמן במילישניות להגדרת לחיצה כפולה
  //     onRowSelect([rows.find(row => row.id === rowIndex)])
  //     setSelectedRows({ ...selectedRows, lastClick: null }); // איפוס הזמן ללחיצה כפולה
  //   } else {
  //     handleRowSelection(rowIndex);
  //     setSelectedRows({ ...selectedRows, lastClick: currentTime });
  //   }
  // };
  const handleRowClick = (rowIndex) => {
    console.log('step 1');
    
    const selectedRow = rows[rowIndex];
    const currentTime = new Date().getTime();
    if (selectedRows.lastClick && currentTime - selectedRows.lastClick < 300) {
      onRowSelect([selectedRow]);
      setSelectedRows({ ...selectedRows, lastClick: null });
    } else {
      handleRowSelection(rowIndex);
      setSelectedRows({ ...selectedRows, lastClick: currentTime });
    }
  };

  // const addNewRow = () => {
  //   setRows([...rows, { ...rowStructure }]);
  // };

  const handleDeleteRow = (index) => {
    const rowToDelete = rows[index];

    if (rowToDelete.locked && !hasLockedPermission()) {
      alert('לא ניתן למחוק רשומה נעולה.');
      return;
    }

    if (rowToDelete.required && !hasRequiredPermission()) {
      alert('לא ניתן למחוק רשומה חובה.');
      return;
    }

    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleEditRow = (rowIndex) => {
    // הוספה או הסרה של שורה ממצב עריכה
    if (editableRows.includes(rowIndex)) {
      setEditableRows(editableRows.filter(index => index !== rowIndex));
    } else {
      setEditableRows([...editableRows, rowIndex]);
    }
  };

  useEffect(() => {
    onRowsChange(rows);
  }, [rows, onRowsChange]);

  useEffect(() => {
    // מסנכרן את הרשומות שנבחרו עם הרשומות המסוננות
    const updatedSelectedRows = selectedRows.rows.filter(selectedRow => rows.includes(selectedRow));
    setSelectedRows({ ...selectedRows, rows: updatedSelectedRows });
  }, [rows]);

  // Handle column resizing for RTL
  const handleMouseDown = (index, e) => {
    const startX = e.clientX;
    const startWidth = columnWidths[index];

    const onMouseMove = (e) => {
      const deltaX = startX - e.clientX; // הפוך כיוון ל-RTL
      const newWidths = [...columnWidths];
      newWidths[index] = Math.max(startWidth + deltaX, 120); // עדכון ערך מינימלי ל-60 פיקסלים
      setColumnWidths(newWidths);

      // עדכון הסטייט של העמודות המעודכנות
      const newUpdatedColumns = [...updatedColumns];
      newUpdatedColumns[index] = { ...newUpdatedColumns[index], width: newWidths[index] };
      setUpdatedColumns(newUpdatedColumns);
    };

    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  return (
    <div style={{ width: '100%' }}>

      {/* Group of buttons */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
        <TableActions columns={updatedColumns} rows={rows} />
      </div>

      <div style={{ width: '100%', minHeight: '400px', maxHeight: '400px', overflowY: 'auto' }}>
        <Table style={{ width: '100%', tableLayout: 'auto', position: "relative" }} size="small">
          <TableHead sx={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 100 }}>
            <TableRow>
              {/* <TableCell style={{ minWidth: '50px', maxWidth: '50px' }}>בחירה</TableCell> */}
              {/* צ'קבוקס ראשי לבחירה של כל השורות */}
              <TableCell style={{ minWidth: '5px', maxWidth: '5px', textAlign: 'center', paddingLeft: '35px', }}>
                <Checkbox
                  size="small"
                  checked={selectedRows.rows.length === rows.length && rows.length > 0}
                  indeterminate={selectedRows.rows.length > 0 && selectedRows.rows.length < rows.length}
                  onChange={() => {
                    if (selectedRows.rows.length === rows.length) {
                      // אם כל הרשומות נבחרות, נבטל את כולן
                      setSelectedRows({ rows: [], lastClick: null });
                    } else {
                      // אחרת נבחר את כל הרשומות
                      setSelectedRows({ rows: [...rows], lastClick: null });
                    }
                  }}
                />
              </TableCell>
              {columns.map((column, index) => (
                <TableCell key={index}
                  style={{
                    minWidth: Math.max(columnWidths[index], 120), // מוודא שלא יצטמצם לפחות מ-60 פיקסלים
                    position: 'relative'
                  }}
                >
                  {/* הצגת טקסט עם שלוש נקודות במקרה של חוסר מקום */}
                  <div
                    style={{
                      maxWidth: columnWidths[index] - 40, // וידוא שהרוחב לא חורג
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      paddingLeft: '30px' // הוספת מרווח מימין כדי שלא יתנגש עם האייקון
                    }}
                  >
                    {column.headerName}
                  </div>
                  {/* אייקון סינון */}
                  <IconButton
                    size="small"
                    onClick={(e) => handleFilterClick(e, column)} // פונקציה לפתיחת תפריט הסינון
                    style={{
                      position: 'absolute',
                      left: '8px', // מיקום האייקון בצד שמאל
                      top: '50%',
                      transform: 'translateY(-50%)',
                      zIndex: 2
                    }}
                  >
                    <FilterListIcon fontSize="small" />
                  </IconButton>

                  <div
                    style={{
                      position: 'absolute',
                      left: '-7px', // הרחבת האזור 7 פיקסלים לשני הצדדים
                      top: '50%', // מיקום במרכז
                      transform: 'translateY(-50%)',
                      height: '60%',
                      width: '24px', // הרחבת האזור ל-14 פיקסלים
                      cursor: 'col-resize',
                      zIndex: 1, // לוודא שהאזור יהיה מעל אלמנטים אחרים
                    }}
                    onMouseDown={(e) => handleMouseDown(index, e)}
                  >
                    {/* Visible Divider */}
                    <div
                      style={{
                        width: '5px',
                        height: '100%',
                        margin: '0 auto',
                        backgroundColor: '#ccc',
                      }}
                    />
                  </div>
                </TableCell>
              ))}
              <TableCell style={{ minWidth: '50px', maxWidth: '50px' }}></TableCell>
              <TableCell style={{ minWidth: '50px', maxWidth: '50px' }}></TableCell>

              {/* עמודת Spacer */}
              <TableCell style={{ width: '100%' }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentRows.map((row, index) => (
              <TableRow
                key={index}
                style={{
                  backgroundColor: selectedRows.rows.includes(row) ? '#e0f7fa' : 'inherit',
                  cursor: 'pointer',
                  height: '40px', // גובה קבוע של כל שורה
                  transition: 'background-color 0.3s', // אפקט של מעבר חלק לרקע בעת ריחוף
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.2)'; // כהות של 20%
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = selectedRows.rows.includes(row) ? '#e0f7fa' : 'inherit';
                }}
                onClick={(e) => {
                  console.log('step 0');
                  
                  if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'BUTTON') {
                    handleRowClick(row.id);
                  }
                }}
              >
                {/* עמודת בחירה */}
                <TableCell style={{ minWidth: '50px', maxWidth: '50px', textAlign: 'center' }}>
                  <Checkbox
                    size="small"
                    checked={selectedRows.rows.includes(row)}
                    onChange={() => handleRowSelection(row.id)}
                  />
                </TableCell>
                {columns.map((column, index) => (
                  <TableCell key={index} style={{ width: columnWidths[index] }}>
                    {editableRows.includes(index) ? (
                      column.type === 'select' ? (
                        <Select
                          value={row[column.field]}
                          onChange={(e) => handleInputChange(index, column.field, e.target.value)}
                          fullWidth
                          size="small"
                          disabled={((row.locked && !hasLockedPermission()) || (row.required && !hasRequiredPermission()))}
                        >
                          {column.options.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      ) : column.type === 'checkbox' ? (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={row[column.field]}
                              onChange={(e) => handleInputChange(index, column.field, e.target.checked)}
                              disabled={row.locked && !hasLockedPermission()}
                            />
                          }
                          label={column.label}
                        />
                      ) : (
                        <TextField
                          type={column.inputType || 'text'}
                          value={row[column.field]}
                          onChange={(e) => handleInputChange(index, column.field, e.target.value)}
                          fullWidth
                          size="small"
                          disabled={((row.locked && !hasLockedPermission()) || (row.required && !hasRequiredPermission()))}
                        />
                      )
                    ) : (
                      // הצגת טקסט בלבד אם השורה לא בעריכה
                      <div>
                        {String(row[column.field])}
                      </div>
                    )}
                  </TableCell>
                ))}
                {/* עמודת עריכה */}
                <TableCell style={{ minWidth: '50px', maxWidth: '50px', textAlign: 'center' }}>
                  <Tooltip title="עריכה">
                    <IconButton
                      onClick={() => handleEditRow(index)}
                    >
                      <EditIcon style={{ color: 'lightblue' }} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
                {/* עמודת מחיקה */}
                <TableCell style={{ minWidth: '50px', maxWidth: '50px', textAlign: 'center' }}>
                  <Tooltip
                    title={row.locked ?
                      (hasLockedPermission() ? "הסר למרות שנעול" : "רשומה נעולה, לא ניתן למחוק") :
                      row.required ?
                        (hasRequiredPermission() ? "הסר למרות שחובה" : "רשומת חובה, לא ניתן למחוק") :
                        "מחיקה"}>
                    <span>
                      <IconButton
                        onClick={() => handleDeleteRow(index)}
                        disabled={row.locked && (!hasLockedPermission() || !hasRequiredPermission())}
                      >
                        <DeleteIcon color={((row.locked && !hasLockedPermission()) || (row.required && !hasRequiredPermission())) ? "disabled" : "error"} />
                      </IconButton>
                    </span>
                  </Tooltip>
                </TableCell>

                {/* עמודת Spacer */}
                <TableCell style={{ width: '100%' }}></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      {/* שורה לסיכום בחירות מחוץ לאזור הגלילה */}
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', alignItems: 'center' }}>
        {/* סיכום בחירות */}
        <div style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', padding: '10px 15px' }}>
          <Typography variant="caption" style={{ fontWeight: 'bold', textAlign: 'center' }}>
            {`${selectedRows.rows.length} מתוך ${rows.length} שורות נבחרו`}
          </Typography>
        </div>
        <div style={{ display: 'flex' }}>
          {/* סיכום בחירות */}
          <div style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', padding: '10px 15px' }}>
            <Typography variant="caption" style={{ fontWeight: 'bold', textAlign: 'center' }}>
              {`עמוד ${currentPage} מתוך ${Math.ceil(rows.length / rowsPerPage)}`}
            </Typography>
          </div>
          {/* פילטר לבחירת מספר רשומות להצגה */}
          <div>
            <Select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              size="small"
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={rows.length}>הכל</MenuItem>
            </Select>
          </div>
          {/* ניווט בין עמודים */}
          <div>
            <IconButton onClick={handleFirstPage} disabled={currentPage === 1}>
              <LastPageIcon />
            </IconButton>
            <IconButton onClick={handlePreviousPage} disabled={currentPage === 1}>
              <NavigateNextIcon />
            </IconButton>
            <IconButton onClick={handleNextPage} disabled={currentPage === Math.ceil(rows.length / rowsPerPage)}>
              <NavigateBeforeIcon />
            </IconButton>
            <IconButton onClick={handleLastPage} disabled={currentPage === Math.ceil(rows.length / rowsPerPage)}>
              <FirstPageIcon />
            </IconButton>
          </div>
        </div>
      </div>

      {/* קומפוננטת הפילטר */}
      {filterColumn && (
        <ColumnFilter
          anchorEl={anchorEl}
          onClose={handleFilterClose}
          onFilterChange={handleFilterChange}
          columnType={filterColumn?.input} // העברת סוג העמודה
          filterValues={filters[filterColumn?.field] || {}} // מעביר את הערכים הקיימים של הפילטר
        />
      )}
    </div>
  );
};

export default GenericTable;
